import React from "react"
import { useEffect, useState } from "react"
import QRCode from "react-qr-code";
import { Modal, Button, Form } from "react-bootstrap"
import { BusinessFetchAPI } from "../../../api/Business"



const ModalLinkShopProduct = ({ group_id, branchoffice_id }) => {
    const [showModal, setShowModal] = useState(false)
    const [linkproduct, setLinkproduct] = useState("")
    const [eventhandler, setEventhandler] = useState(0)
    let token = localStorage.getItem("x-access-token")
    let user = ""

    if (localStorage.getItem("user") !== undefined && localStorage.getItem("user") !== null && localStorage.getItem("user") !== "") {
        user = JSON.parse(localStorage.getItem("user"))
    }


    const getBusinessById = async () => {

        try {
            const response = await BusinessFetchAPI.getBusinessById(user.business_id, token);
            console.log(response.data.data.domain);
            console.log(group_id);


            let url = `https://${response.data.data.domain}/cart/product/${group_id}X${branchoffice_id}`
            setLinkproduct(url);
            console.log(url);

        } catch (error) {
            console.log(error);
        }
    }



    return (
        <>

            <div className="fw-bold">
                <button className='btn btn-primary btn-sm border-0 m-2' onClick={() => (setShowModal(true), getBusinessById())}>
                    <i class="uil uil-shopping-bag"> Generar link de compra</i>
                </button>
            </div>
            {/*Modal add up to product*/}
            < Modal
                show={showModal}
                onHide={() => (setShowModal(false))}
                size='large'
                centered >

                <Modal.Body>
                    <div className="d-flex justify-content-center border-bottom-0">
                        <h1 className="modal-title fw-bold fs-5">
                            <i class="uil uil-qrcode-scan"> Link de compra en linea</i>
                        </h1>
                    </div>
                    <div className="m-4 d-flex align-items-center justify-content-center ">
                        <QRCode value={linkproduct}
                            size={150}
                            bgColor="#ffffff" // Color de fondo
                            fgColor="#000000" // Color del texto
                            level="H" />
                    </div>

                    <p className="d-flex justify-content-center">{linkproduct}</p>

                    <Button onClick={() => (setShowModal(false))}>Cerrar</Button>
                </Modal.Body>
            </Modal >
        </>
    )
}

export default ModalLinkShopProduct